import { IonButton, IonCard, IonCardContent, IonCol, IonImg, IonLabel, IonRow, IonText } from "@ionic/react"
import { isWebView } from "../../library/Funcs";
import Image from "../image/Image";

import './EventItem.css';

interface Props {
    id: number,
    image: string,
    title: string,
    price: string,
    status: string,
    link: string
}

const EventItem: React.FC<Props> = (props) => {
    return <IonCard routerLink={props.link} button className="event-item">
        <Image src={props.image} />

        <div className="text-section">
            <IonText className="title">{props.title}</IonText>

            <div className="price-container">
                <IonLabel class="price">{props.price}</IonLabel>
            </div>
        </div>
        <span className="badge ion-float-left">{props.status}</span>
    </IonCard>
}

export default EventItem